package theme
import androidx.compose.material3.ColorScheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.ui.graphics.Color


val mainColor = //Color.Yellow
    Color(0xFFD6152C)




val inTvBackground = Color(0xFF0B0C10)          // Deep, rich slate black
val inTvBackgroundSecondary = Color(0xFF15161C) // Slightly elevated cool gray
val imageBackground = Color(0xFF111217)         // Bridge between the two
val imageCardBackground = Color(0xFF111117)     // Distinct enough to pop off the background


val inTvLightBackground = Color(0xFFEAEAEA) //Color(0xFF17171B)/#FF17171B
val imageLightBackground = Color(0xFFA9A9A9)
val imageLightCardBackground = Color(0xFFD5D4D4) //Color(0xFF17171B)/#FF17171B




// src/flavor/intvplus/kotlin/theme/FlavorTheme.kt
val flavorDarkColorScheme: ColorScheme = darkColorScheme(
    primary =mainColor,     //buttons
    surface = Color.Transparent, // or any background color
    onSurface = Color.White,     // text/icons on that surface
    onSurfaceVariant = Color.White,
    onPrimary = Color.Black,   //button contents
    secondary = Color.White,
    background = inTvBackground,
    onBackground = Color.White,
    onSecondary = Color.White,
    secondaryContainer = imageBackground,
    surfaceContainer=inTvBackground,

    surfaceVariant = imageCardBackground, //card container

    errorContainer = Color.Red,//.lightenColor(0.1f),

    primaryContainer = mainColor,

    )

val flavorLightColorScheme: ColorScheme = lightColorScheme(
    primary = mainColor,                 // buttons (keep brand color)
    onPrimary = Color.White,              // button text/icons

    secondary = inTvBackground,
    onSecondary = Color.White,

    background = inTvLightBackground,             // app background
    onBackground = Color.Black,            // main text

    surface = Color.Transparent,           // scaffold / surfaces
    onSurface = Color.Black,               // text/icons on surface
    onSurfaceVariant = Color.DarkGray,
    surfaceContainer=inTvLightBackground,

    surfaceVariant = imageLightCardBackground, // cards
    secondaryContainer = imageLightBackground, // image backgrounds
    errorContainer = Color.Red,//.lightenColor(0.1f),

    primaryContainer = mainColor,           // highlighted containers
)